<div class="pricing-step">
  <div class="row">
    <div class="col-12">
      <!-- Step 1: Rental Rates Confirmation -->
      <div *ngIf="currentStep === 'rentalRates' && entity && !machineLoading">
        <div class="d-flex mx-5 px-5">
          <img src="https://company.rubbl.com/pubweb/marketplace/images/icons/rubbl-ai-2.png" alt="Rubbl AI" class="ai-logo-loading mb-2 img-fluid" />
        </div>
        <p class="font-weight-light">
          We provide rental rate recommendations aligned with your local region, while you retain full control and determine your final pricing.
        </p>

        <!-- Earnings Display -->
        <div class="alert alert-success font-weight-light p-3 mb-4" *ngIf="hasSuggestedRates()">
          <div class="text-center mb-2"><i class="icon-money mr-2"></i> <strong>Your Earnings</strong></div>
          <div class="d-flex justify-content-around">
            <div class="d-flex flex-column text-center">
              <span class="font-weight-light small">Weekly</span>
              <span class="text-success h4 font-weight-bold mb-0">{{
                calculateWeeklyEarnings(suggestedWeeklyRateFromMonthly) | currency: "USD":"symbol":"1.0-0"
              }}</span>
            </div>
            <div class="d-flex flex-column text-center">
              <span class="font-weight-light small">Monthly</span>
              <span class="text-success h4 font-weight-bold mb-0">{{
                calculateMonthlyEarnings(analysisResult.monthlyRate) | currency: "USD":"symbol":"1.0-0"
              }}</span>
            </div>
          </div>
        </div>

        <!-- Show suggested rates if available from AI -->
        <div class="suggested-rates" *ngIf="hasSuggestedRates() && !showDropdown">
          <div class="bg-light rounded border p-4 mb-4">
            <h6 class="mb-3 font-weight-bold text-dark">Suggested Rental Rates</h6>
            <div class="row text-center">
              <div class="col-6">
                <div class="rate-card bg-white rounded border p-3 mx-1">
                  <div class="small text-muted mb-2 font-weight-normal">Weekly</div>
                  <div class="h5 font-weight-bold text-dark mb-0">{{ suggestedWeeklyRateFromMonthly | currency: "USD":"symbol":"1.0-0" }}</div>
                </div>
              </div>
              <div class="col-6">
                <div class="rate-card bg-white rounded border p-3 mx-1">
                  <div class="small text-muted mb-2 font-weight-normal">Monthly</div>
                  <div class="h5 font-weight-bold text-dark mb-0">{{ analysisResult.monthlyRate | currency: "USD":"symbol":"1.0-0" }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button type="button" class="btn btn-success btn-lg mr-3" (click)="acceptSuggestedRates()" [disabled]="loading">
              <i class="icon-check mr-2"></i>Yes, use these rates
            </button>
            <button type="button" class="btn btn-outline-secondary btn-lg" (click)="rejectSuggestedRates()" [disabled]="loading">
              <i class="icon-edit mr-2"></i>No, I'll set my own
            </button>
          </div>
        </div>

        <!-- Manual rate entry -->
        <div class="manual-rates" *ngIf="!hasSuggestedRates() || showDropdown">
          <!-- Earnings Display for Custom Rates -->
          <div class="alert alert-success font-weight-light p-3 mb-4" *ngIf="confirmedData.rentalRates.weekly || confirmedData.rentalRates.monthly">
            <div class="text-center mb-2"><i class="icon-money mr-2"></i> <strong>Your Earnings</strong></div>
            <div class="d-flex justify-content-around">
              <div class="d-flex flex-column text-center">
                <span class="font-weight-light small">Weekly</span>
                <span class="text-success h4 font-weight-bold mb-0">{{ getCustomWeeklyEarnings() | currency: "USD":"symbol":"1.0-0" }}</span>
              </div>
              <div class="d-flex flex-column text-center">
                <span class="font-weight-light small">Monthly</span>
                <span class="text-success h4 font-weight-bold mb-0">{{ getCustomMonthlyEarnings() | currency: "USD":"symbol":"1.0-0" }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Weekly Rate</label>
                <div class="input-group rental-rate-input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control" [(ngModel)]="confirmedData.rentalRates.weekly" (ngModelChange)="onCustomRentalRateChange()" mask="separator" thousandSeparator="," />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Monthly Rate</label>
                <div class="input-group rental-rate-input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="confirmedData.rentalRates.monthly"
                    (ngModelChange)="onMonthlyRentalRateChange()"
                    mask="separator"
                    thousandSeparator=","
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button type="button" class="btn btn-success btn-lg" (click)="saveRentalRates()" [disabled]="(!confirmedData.rentalRates.weekly && !confirmedData.rentalRates.monthly) || loading">Next</button>
          </div>
        </div>
      </div>

      <!-- Step 2: Rent to Own Configuration -->
      <div *ngIf="currentStep === 'rentToOwn' && entity && !machineLoading">
        <div class="d-flex align-items-center">
          <i class="icon-info fs-30 text-primary mr-2"></i>
          <div class="fs-30 teko">Rent To Sell</div>
        </div>
        <div class="list-group mt-3">
          <div class="list-group-item d-lg-flex align-items-center">
            <div class="col-lg-6">
              <p class="mb-1">Rent To Sell Starting Price</p>
              <p class="fs-14 font-weight-light mb-0">We recommend the Rent To Sell Starting Price should be set 5% to 10% higher than your cash sale price.</p>
            </div>
            <div class="col-lg-4 offset-lg-1 justify-content-center d-flex">
              <div class="form-group d-flex align-items-baseline mb-0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    class="form-control"
                    [(ngModel)]="entity.purchasePrice"
                    (keyup)="onRpoPriceChange($event.target.value)"
                    type="text"
                    mask="separator"
                    thousandSeparator=","
                    [maxLength]="9"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="list-group-item d-lg-flex align-items-center">
            <div class="col-lg-6">
              <p class="mb-1">Simulate Rental Duration</p>
              <p class="fs-14 font-weight-light mb-0">The RTO option will be available to the renter for a max of 6 months.</p>
            </div>
            <div class="col-lg-4 offset-lg-1 d-flex justify-content-center">
              <div class="form-group d-flex align-items-baseline mb-0">
                <select class="form-control" (change)="onRpoDurationChange($event.target.value)">
                  <option value="1">1 month</option>
                  <option value="2">2 months</option>
                  <option value="3">3 months</option>
                  <option value="4">4 months</option>
                  <option value="5">5 months</option>
                  <option value="6">6 months</option>
                </select>
              </div>
            </div>
          </div>
          <div class="list-group-item d-lg-flex align-items-center" *ngFor="let row of comparisonTable.rows">
            <div class="col-lg-6">
              <p class="mb-1" [innerHtml]="row.columns[0].label"></p>
            </div>
            <div class="col-lg-6 text-center">
              <p class="mb-1" [innerHtml]="row.columns[1].label"></p>
            </div>
          </div>
        </div>

        <div class="text-center mt-4">
          <button type="button" class="btn btn-success btn-lg" (click)="proceedToSellItNow()">Continue to Sell It Now</button>

          <div class="mt-3">
            <button type="button" class="btn btn-link text-success" (click)="goBackToRentalRates()">
              <i class="icon-arrow-left mr-1"></i>
              Back to Rental Rates
            </button>
          </div>
        </div>
      </div>

      <!-- Step 3: Sell It Now Configuration -->
      <div *ngIf="currentStep === 'sellItNow' && entity && !machineLoading">
        <div class="d-flex align-items-center">
          <i class="icon-earnings fs-30 text-primary mr-2"></i>
          <div class="fs-30 teko">Sell It Now</div>
        </div>
        <div class="form-text font-weight-light mb-2">
          Rubbl will help you promote your machine to a network of vetted buyers and make your sale straightforward.<br />
          <br />When your machine sells, a <b>{{ inventoryService.getSellItNowFeePercentage(account?.companyType) }}%</b> marketplace fee applies to the final sale price. Enter your price below to see your estimated earnings.<br />
          <br />
          <div class="form-text font-weight-light">
            Text us at <a href="tel:(855) 535-9782">(855) 535-9782</a> or email
            <a href="mailto:support@rubbl.com">support@rubbl.com</a> if you have any questions or suggestions about selling your machine.
          </div>
        </div>
        <div class="form-group px-0 mb-3">
          <label for="buyItNowPrice" class="mb-0">Selling Price</label>
          <div class="input-group col-7 col-md-6 px-0">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
            <input
              type="text"
              class="form-control"
              id="buyItNowPrice"
              name="buyItNowPrice"
              [(ngModel)]="entity.buyItNowPrice"
              mask="separator"
              placeholder="e.g. 4,999"
              [maxLength]="8"
              thousandSeparator=","
            />
          </div>
        </div>
        <div class="form-text mb-2">
          <div class="d-flex align-items-center">
            <div class="fs-30 teko">Potential Earnings</div>
          </div>
          <div class="d-md-flex justify-content-around">
            <div class="d-flex flex-column align-items-center">
              <div class="fs-26 teko" style="margin-bottom: -16px">You</div>
              <div class="fs-40 text-success" *ngIf="entity.buyItNowPrice">
                {{ inventoryService.calculateSaleProceeds(entity.buyItNowPrice, account?.companyType) | currency: "USD":"symbol":"1.0-0" }}
              </div>
              <div class="fs-40" *ngIf="!entity.buyItNowPrice">-</div>
            </div>
            <div class="d-flex flex-column align-items-center">
              <div class="fs-26 teko" style="margin-bottom: -16px">Rubbl</div>
              <div class="fs-40" *ngIf="entity.buyItNowPrice">
                {{ entity.buyItNowPrice - inventoryService.calculateSaleProceeds(entity.buyItNowPrice, account?.companyType) | currency: "USD":"symbol":"1.0-0" }}
              </div>
              <div class="fs-40" *ngIf="!entity.buyItNowPrice">-</div>
            </div>
          </div>
        </div>
        <div class="alert alert-success font-weight-light p-2 d-flex align-items-center" role="alert">
          Once your machine is approved it will be available on Rubbl for sale.
        </div>

        <div class="text-center mt-4">
          <button type="button" class="btn btn-success btn-lg" (click)="proceedToOptions()">Continue to Options</button>

          <div class="mt-3">
            <button type="button" class="btn btn-link text-success" (click)="goBackToRentToOwn()">
              <i class="icon-arrow-left mr-1"></i>
              Back to Rent To Sell
            </button>
          </div>
        </div>
      </div>

      <!-- Loading state -->
      <div *ngIf="machineLoading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="text-muted mt-3">Loading machine details...</p>
      </div>

      <!-- Validation Messages -->
      <div class="alert alert-danger mt-3" *ngIf="validationErrors.length > 0">
        <ul class="mb-0">
          <li *ngFor="let error of validationErrors">{{ error }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
